export default __webpack_public_path__ + "static/media/welcome-to-kontrolujeme.f4ee178a.svg";